import { render } from "./TabFormModal.vue?vue&type=template&id=b5fb1f96&scoped=true"
import script from "./TabFormModal.vue?vue&type=script&lang=js"
export * from "./TabFormModal.vue?vue&type=script&lang=js"

import "./TabFormModal.vue?vue&type=style&index=0&id=b5fb1f96&lang=scss&scoped=true"

import exportComponent from "/root/workspace/Collection_EVMd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5fb1f96"]])

export default __exports__